import React from "react";
import { useNavigate } from "react-router-dom";
import "./Hero.css";

/*
 * PLAYER IMAGE
 * Replace the src below with the composite sports-player asset from your
 * public folder. Common platform path: /assets/images/hero-players.png
 * If the image lives elsewhere, update HERO_PLAYER_SRC.
 */
const HERO_PLAYER_SRC = "/assets/image/guy_happy_mobile.png";

export default function Hero() {
  const navigate = useNavigate();

  return (
    <div className="hero_wrapper">
      {/* Left � sports player composite */}
      <div className="hero_player_col">
        <img
          className="hero_player_img"
          src={HERO_PLAYER_SRC}
          alt="Sports players"
        />
      </div>

      {/* Right � tagline and CTA */}
      <div className="hero_content_col">
        <p className="hero_tagline_gold">SPORTS NEWEST &amp;</p>
        <p className="hero_tagline_white">MOST INTERACTIVE</p>
        <p className="hero_tagline_white">PREDICTION GAME!</p>

        <div className="hero_cta_stack">
          <button
            className="hero_btn_signup"
            onClick={() => navigate("/register")}
          >
            SIGN UP
          </button>
          <button
            className="hero_btn_login"
            onClick={() => navigate("/login")}
          >
            LOGIN
          </button>
        </div>
      </div>
    </div>
  );
}